import PropTypes from 'prop-types'
import { Fragment } from 'react'

import Group from 'components/charts/Group'
import theme from 'theme'

export default function ChartDataBoundryLines({
  height,
  startX,
  startLabel,
  endX,
  endLabel,
  endStroke = theme.colors.red[0]
}) {
  return (
    <Group>
      {Boolean(startLabel) && (
        <Fragment>
          <line
            stroke={theme.colors.green[0]}
            strokeDasharray="2,2"
            strokeWidth={1.5}
            x1={startX}
            x2={startX}
            y1={height}
            y2={0}
          />
          <text
            css={{
              fill: theme.colors.green[0],
              textAnchor: 'middle',
              fontSize: 11
            }}
            dy="0.1em"
            x={startX}
            y={-12}
          >
            {startLabel}
          </text>
        </Fragment>
      )}
      {Boolean(endLabel) && (
        <Fragment>
          <line
            stroke={endStroke}
            strokeDasharray="2,2"
            strokeWidth={1.5}
            x1={endX}
            x2={endX}
            y1={height}
            y2={0}
          />
          <text
            css={{
              fill: endStroke,
              textAnchor: 'middle',
              fontSize: 11
            }}
            dy="0.1em"
            x={endX}
            y={-12}
          >
            {endLabel}
          </text>
        </Fragment>
      )}
    </Group>
  )
}

ChartDataBoundryLines.propTypes = {
  height: PropTypes.number,
  startX: PropTypes.number,
  startLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  endX: PropTypes.number,
  endLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  endStroke: PropTypes.string
}
